export const CATALOG = 'CATALOG';
export const SOURCING = 'SOURCING';
